let thousandSeparator = (num) => {
  try {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, 
      ","
      // " "
    );
  } catch (err) {
    return 0;
  }
};

export { thousandSeparator };
